import { CompanyDetailsWebPage } from 'commons/types/DTO/bank'

export type CompanyDetailsPageProps = {
  data: CompanyDetailsWebPage
  onOpenClientPortalInviteDialog: () => void
}
